import { MessageCircle, ArrowDown, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import MailchimpSignupForm from "@/components/MailchimpSignupForm";

const SignupSection = () => {
  return (
    <section id="anmalan" className="py-20 px-3 sm:px-4 bg-gradient-to-br from-[#003056]/5 to-[#FF6D29]/10">
      <div className="w-full mx-auto max-w-2xl">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-[#FF6D29]/10 text-[#FF6D29] px-4 py-2 rounded-full mb-4 text-sm font-medium">
            <MessageCircle className="h-4 w-4" />
            Utskickslistan
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#003056] mb-4">
            Få påminnelser om kommande träffar
          </h2>
          <p className="text-slate-600">
            Anmäl dig en gång så får du information och påminnelser inför kommande träffar.
            Du väljer alltid själv vilka träffar du vill delta i.
          </p>
          <p className="text-slate-600 mt-2 font-medium">
            Du behöver inte anmäla dig separat till varje träff.
          </p>
        </div>


        {/* Avgift – kompakt och kollapsbar */}
        <details className="group bg-white border border-slate-200 rounded-2xl mb-6 overflow-hidden [&_summary::-webkit-details-marker]:hidden">
          <summary className="flex items-center justify-between gap-4 p-5 cursor-pointer list-none hover:bg-slate-50 transition-colors">
            <div className="flex items-center gap-3 min-w-0">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#FF6D29]/10 text-[#FF6D29] flex items-center justify-center font-bold text-sm">
                150
              </div>
              <div className="min-w-0">
                <p className="font-semibold text-[#003056] leading-tight">
                  Avgift per möte
                </p>
                <p className="text-xs text-slate-500 mt-0.5">
                  Tryck för att läsa mer
                </p>
              </div>
            </div>
            <ArrowDown className="h-4 w-4 text-slate-400 flex-shrink-0 transition-transform group-open:rotate-180" />
          </summary>
          <div className="px-5 pb-5 pt-1 border-t border-slate-100">
            <p className="text-sm text-slate-600 leading-relaxed mb-3">
              Deltagaravgiften är 150 kronor per träff du deltar i. Det finns inget medlemskap och
              ingen bindningstid.
            </p>
            <p className="text-sm text-slate-600 leading-relaxed mb-3">
              Affärsnätverkets Företagsnätverk bygger på deltagare som ser värdet i träffarna och vill hjälpa oss att fortsätta arrangera och utveckla nätverket.&nbsp;Inga återbetalningar.&nbsp;
            </p>
            <p className="text-xs text-slate-500 leading-relaxed mb-4">
              Avgiften hanteras av Tomas Friman Enskild Firma.&nbsp;OBS: Alla är välkomna, men det är inte en mötesplats för arbetssökande, däremot hjälper vi gärna blivande entreprenörer.
            </p>
            <Button
              asChild
              size="sm"
              variant="outline"
              className="border-[#003056] text-[#003056] hover:bg-[#003056] hover:text-white"
            >
              <a href="/bidra" target="_blank" rel="noopener noreferrer">
                Betala deltagaravgiften
              </a>
            </Button>
          </div>
        </details>

        {/* Policy – kollapsbar */}
        <details className="group bg-slate-50/70 border border-slate-200 rounded-2xl mb-6 overflow-hidden [&_summary::-webkit-details-marker]:hidden">
          <summary className="flex items-center justify-between gap-4 p-5 cursor-pointer list-none hover:bg-slate-100/70 transition-colors">
            <div className="flex items-center gap-3 min-w-0">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#003056]/10 text-[#003056] flex items-center justify-center">
                <ShieldCheck className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <p className="font-semibold text-[#003056] leading-tight">
                  Affärsnätverkets regler och uppförandekod
                </p>
                <p className="text-xs text-slate-500 mt-0.5">
                  Så håller vi träffarna enkla och värdefulla
                </p>
              </div>
            </div>
            <ArrowDown className="h-4 w-4 text-slate-400 flex-shrink-0 transition-transform group-open:rotate-180" />
          </summary>
          <div className="px-5 pb-5 pt-1 border-t border-slate-200/70">
            <ul className="text-sm text-slate-600 leading-relaxed space-y-3 mt-3">
              <li>
                Våra nätverksträffar ska vara en trygg plats för företagare att dela tankar, frågor och erfarenheter.
              </li>
              <li>Varken vi som arrangör eller deltagare spelar in mötena.</li>
              <li>
                Vi håller en god ton och visar respekt för varandra. Alla ska få utrymme att prata.
              </li>
              <li>
                Fokus ligger på samtal, erfarenhetsutbyte och att hjälpa varandra framåt. Du får
                självklart berätta om din verksamhet, men träffarna bygger inte på säljpitchar.
              </li>
              <li>Du delar det du vill, i din takt.</li>
            </ul>
            <p className="text-xs text-slate-500 mt-4 italic">
              När du deltar i en träff godkänner du dessa enkla regler.
            </p>
          </div>
        </details>

        {/* Mailchimp Form Embed */}
        <div className="bg-white border border-slate-200 rounded-2xl p-4 sm:p-8 shadow-lg mb-6">
          <MailchimpSignupForm />
        </div>

        {/* GDPR Notice */}
        <p className="text-xs text-slate-500 text-center max-w-lg mx-auto leading-relaxed">
          Vi sparar dina uppgifter för att kunna skicka ut inbjudningar till nätverksträffarna
          och ge dig tillgång till vårt nyhetsbrev. Du kan när som helst avanmäla dig via länk
          i våra utskick. Vi hanterar dina uppgifter enligt GDPR och delar dem aldrig med tredje part.
        </p>
      </div>
    </section>
  );
};

export default SignupSection;
